<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
export default {
    mounted() {
        //document.body.style.backgroundColor = isset(this.$route.params.bg) ? `#${this.$route.params.bg}` : '#FFFFFF';
        //document.body.style.color           = isset(this.$route.params.fg) ? `#${this.$route.params.fg}` : '#000000';
        document.body.style.backgroundColor = `#${this.$route.params.bg}`
        document.body.style.color           = `#${this.$route.params.fg}`;
    }
}
</script>
<style>
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        font-family: Arial, Helvetica, sans-serif;
        line-height: 1.4;
    }
</style>
